const SearchType = {
    SIMPLE: 'simple',
    CUSTOM: 'custom',    
};

// return SearchType class
export default SearchType;